import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";

import { CustomModal } from "../../../../components/CustomModal";
import { ConfirmModal } from "../../../../components/CustomModal/ConfirmModal";
import { TrashIcon } from "../../../../components/icons";

interface DeleteToolModalProps {
  toolId: number;
  toolName: string;
  handleDelete: (id: number) => void;
}

const DeleteToolModal: React.FC<DeleteToolModalProps> = ({
  toolId,
  toolName,
  handleDelete,
}) => {
  const [show, setShow] = useState<boolean>(false);

  const openModal = () => setShow(true);
  const closeModal = () => setShow(false);

  const deleteTool = () => {
    handleDelete(toolId);
    closeModal();
    toast.success("Tool deleted successfully!");
  };

  return (
    <>
      <Button variant="light" className="btn-tool-control" onClick={openModal}>
        <TrashIcon />
      </Button>
      {show && (
        <ConfirmModal
          visible={true}
          onCancel={closeModal}
          onSubmit={deleteTool}
          title="Delete tool"
          text={
            <>
              The tool <b>{toolName}</b> will be deleted.
            </>
          }
          okText="Delete"
        />
      )}
    </>
  );
};

export { DeleteToolModal };
